<template>
  <div class="page-content">
    <page-template ref="batchTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '盘点批号', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入盘点批号"}
          ],
          complex: [
            {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
            {
              label: "门店仓库",
              type: "select",
              prop: "warehouseId",
              url: api.warehouse.warehouse,
              data: [],
              param: {relateType: this.$utils.getSysUser().storeId ? 20 : 10},
              span: 12,
            },
            {
              label: "申请人",
              type: "input",
              prop: "voucherName",
              span: 12,
            },
            {
              label: "审核人",
              type: "input",
              prop: "reviewerName",
              span: 12,
            },
            {
              label: '盘点状态',
              type: "select",
              prop: 'status',
              data: this.$utils.getCacheStatus('weBatchNumberOrder.status')
            },
            // {
            //   label: '盘点范围',
            //   prop: 'type',
            //   type: 'radio',
            //   span: 12,
            //   data: [{label: '全场盘点', value: 10}, {label: '单品盘点', value: 20}, {label: '类别盘点', value: 30}, {
            //     label: '品牌盘点',
            //     value: 40
            //   },],
            // },
            {
              label: '审核状态',
              type: 'select',
              prop: 'reviewerStatus',
              defaultValue: 20,
              span: 12,
              data: [
                {label: '未审核', value: 20},
                {label: '已审核', value: 10}
              ],
            },
          ]

        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '盘点差异',
            callback: this.difference,
            code: 'inventoryDifference',
          },
          {
            label: '导出',
            callback: this.exportData,
            code: 'export',
          },
          {
            label: '刷新',
            code: 'refresh',
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            filter: (data) => {
              return (data.reviewerStatus == 20 && data.status == 10) ? true : false;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            // filter: (data) => {
            //   return data.reviewerStatus == 10 ? false : true;
            // }
          },
          {
            label: '作废',
            code: 'nullify',
            type: this.$utils.buttonType.tableOperate,
            callback: this.orderNullify,
            filter: (data) => {//未审核且未开始 可编辑和作废
              return (data.reviewerStatus == 20 && data.status == 10) ? true : false;
            },
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          showSelect: true,
          columns: [
            {label: '盘点批号', prop: 'orderNo', width: '220', align: 'center'},
            // {label: '门店名称', prop: 'storeName', width: '100', align: 'center'},
            // {label: '门店编号', prop: 'storeCode', width: '100', align: 'center'},
            {label: '盘点仓库', prop: 'warehouseName', width: '190', align: 'center'},
            {
              label: '盘点范围',
              prop: 'type',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weBatchNumberOrder.type')
            },
            {
              label: '类别/品牌',
              prop: 'retaleInfo',
              width: '100',
              align: 'center'
            },
            // {
            //   label: '盘点信息',
            //   prop: 'retaleInfo',
            //   width: '190',
            //   align: 'center',
            // },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weBatchNumberOrder.reviewerStatus')
            },
            {
              label: '盘点状态',
              prop: 'status',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weBatchNumberOrder.status')
            },
            {label: '申请人', prop: 'voucherName', width: '80', align: 'center'},
            {label: '申请时间', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '80', align: 'center'},
            {label: '审核时间', prop: 'reviewerDttm', width: '150', align: 'center'},
            {label: '备注', prop: 'remarks', width: '80', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.warehouse.batch
        },
        // 添加字段
        addColumns: {
          labelWidth: "120px",
          span: 12,
          columns: [
            {label: '盘点批号', type: "title", span: 24},
            {
              label: "批号来源",
              type: "select",
              prop: "relateType",
              data: this.$utils.getCacheStatus('weBatchNumberOrder.relateType'),
              defaultValue: this.$utils.getSysUser().storeId ? 20 : 10,
              hidden: true
            },
            {
              label: "业务单号",
              type: "input",
              prop: "orderNo",
              disabled: true
            },
            {
              label: "仓库",
              type: "select",
              prop: "warehouseId",
              url: api.warehouse.warehouse,
              param: {relateType: this.$utils.getSysUser().storeId ? 20 : 10},
              data: [],
              span: 12,
              rule: [
                {required: true, message: '请选择仓库', trigger: 'blur'},
              ],
            },
            {
              label: "制单人",
              type: "input",
              prop: "voucherName",
              defaultValue: this.$utils.getSysUser().name,
              disabled: true
            },
            {
              label: "制单日期",
              type: "input",
              prop: "voucherDttm",
              defaultValue: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
              disabled: true
            },
            {
              label: "审核人",
              type: "input",
              prop: "reviewerName",
              disabled: true
            },
            {
              label: "审核日期",
              type: "input",
              prop: "reviewerDttm",
              disabled: true
            },
            {
              label: "备注",
              type: "textarea",
              prop: "address",
              span: 22
            },
            {label: '盘点信息', type: "title", span: 24},
            {
              label: "盘点范围",
              type: "select",
              prop: "type",
              defaultValue:20,
              data: this.$utils.getCacheStatus('weBatchNumberOrder.type'),
              change: this.typeChange,
              rule: [
                {required: true, message: '请选择盘点范围', trigger: 'blur'},
              ],
            },
            {
              label: "类别",
              type: "select",
              prop: "goodsCategoryMVOList",
              multiple: true,
              hidden: true,
              url: api.archives.categoryList,
              data: [],
              rule: [
                {required: true, message: '请选择盘点类别', trigger: 'blur'},
              ],
            },
            {
              label: "品牌",
              type: "select",
              prop: "goodsBrandMVOList",
              multiple: true,
              hidden: true,
              url: api.archives.brand,
              data: [],
              rule: [
                {required: true, message: '请选择盘点品牌', trigger: 'blur'},
              ],
            },
          ],
          url: api.warehouse.batch
        },
      };
    },
    created() {
      this.$nextTick(() => {
        this.$refs['batchTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(()=>{
      //   this.tableOptions.url = api.warehouse.batch
      //   this.$refs['batchTemplate'].operationSuccess();
      // });
    },
    methods: {
      typeChange(data) {
        let type = data['type'];
        let goodsBrand = this.addColumns.columns.filter(item => item.prop === 'goodsBrandMVOList')[0];
        let goodsCategory = this.addColumns.columns.filter(item => item.prop === 'goodsCategoryMVOList')[0];

        if (40 === type) {  // 品牌盘点
          goodsBrand.hidden = false;
          goodsCategory.hidden = true;

        } else if (30 === type) { // 类别盘点
          goodsBrand.hidden = true;
          goodsCategory.hidden = false;
        } else {
          goodsBrand.hidden = true;
          goodsCategory.hidden = true;
        }
      },
      difference() {
        let tableRows = this.$refs.batchTemplate.getTableSelectRow();
        console.log(tableRows);
        if (tableRows.length == 0 || tableRows.length > 1) {
          this.$message({message: '请选择一条进行操作', type: 'warning'});
        } else {
          let params = tableRows[0];
          if (params['status'] === 15) {
            this.$message({message: '正在生成差异数据，大约十分钟后进行查看。', type: 'warning'});
          } else {
            if (params['status'] === 18 || params['status'] === 20) {
              this.$router.push({path: '/warehouse/inventory/difference?id=' + params.id});
            } else {
              this.$message({message: '该批号未生成差异，不能查看', type: 'warning'});
            }
          }
        }
      },
      orderNullify(form) {
        form.status = 25;
        //订单作废
        this.$axios.fetchPut(api.warehouse.batch, form).then(data => {
          if (data.code === 200) {
            this.$refs['batchTemplate'].operationSuccess();
            this.$notify({
              type: "success",
              title: '作废操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '操作成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '作废操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '操作异常', type: 'error'});
          }
        })
      },
      exportData() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });

        let param = this.$refs['batchTemplate'].getCurrentParams();
        this.$axios.PostBlob(api.warehouse.batchExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '盘点批号_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/warehouse/inventory/Batch.vue